import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(1.000000, 2.000000)">
        <path
          d="M 43.57 60.56 L 36.9 50.85 L 34.02 50.85 L 34.02 60.56 L 29.96 60.56 L 29.96 36.61 L 39.2 36.61 C 41.727 36.61 43.717 37.23 45.17 38.47 C 46.63 39.703 47.36 41.477 47.36 43.79 C 47.36 45.763 46.82 47.33 45.74 48.49 C 44.66 49.643 43.157 50.377 41.23 50.69 L 48.17 60.56 L 43.57 60.56 Z M 39.13 40.12 L 34.02 40.12 L 34.02 47.46 L 39.13 47.46 C 40.457 47.46 41.49 47.127 42.23 46.46 C 42.97 45.8 43.34 44.91 43.34 43.79 C 43.34 42.67 42.97 41.78 42.23 41.12 C 41.49 40.453 40.457 40.12 39.13 40.12 ZM 51.605 36.61 L 55.665 36.61 L 55.665 48.08 L 65.605 36.61 L 70.715 36.61 L 61.045 47.5 L 71.065 60.56 L 65.995 60.56 L 58.115 50.3 L 55.665 53.11 L 55.665 60.56 L 51.605 60.56 L 51.605 36.61 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
